export const uiLocaleCodes = ["en", "ar"] as const
export type UiLocaleCode = (typeof uiLocaleCodes)[number]

export interface UiLocale {
  code: UiLocaleCode
  displayName: string
  autonym: string
  flagEmoji: string
  dir: "ltr" | "rtl"
  formattingLocale?: string
}

export const uiLocales: UiLocale[] = [
  {
    code: "en",
    displayName: "English",
    autonym: "English",
    flagEmoji: "🇺🇸",
    dir: "ltr",
    formattingLocale: "en",
  },
  {
    code: "ar",
    displayName: "Arabic",
    autonym: "العربية",
    flagEmoji: "🇦🇪",
    dir: "rtl",
    formattingLocale: "ar",
  },
]

export const defaultUiLocale: UiLocaleCode = "en"

export function isUiLocaleCode(code: string): code is UiLocaleCode {
  return uiLocaleCodes.includes(code as UiLocaleCode)
}

/**
 * Primary language subtag only: 'ar-AE' → 'ar', 'en_US' → 'en', 'AR' → 'ar'.
 * One Modern Standard Arabic resource serves every Arabic regional variant.
 */
export function normalizeLocale(raw?: string | null): string | undefined {
  if (!raw) return undefined
  const base = raw.trim().toLowerCase().split(/[-_]/)[0]
  return base || undefined
}

export function toUiLocale(raw?: string | null): UiLocaleCode | undefined {
  const normalized = normalizeLocale(raw)
  return normalized && isUiLocaleCode(normalized) ? normalized : undefined
}

export function getUiLocale(code: string): UiLocale {
  return uiLocales.find((l) => l.code === code) ?? uiLocales[0]
}
